export default () => {
	var QuickQuote = {};
	QuickQuote.$ = jQuery;

	QuickQuote.noQuoteMsgEl = null;

	QuickQuote.quotes = [];

	QuickQuote.init = function () {
		var $ = QuickQuote.$;
		// QuickQuote.noQuoteMsgEl = $('.js-no-quote-msg');

		QuickQuote.initSuburbAutocomplete(QuickQuote.$('.js-suburbautocomplete'), {
			response: function (ev, ui) {
				QuickQuote.$.each(ui.content, function (index, item) {
					item.value = item.label;
				});
			},
			select: function (ev, ui) {
				let selectedItem = ui.item;
				if (selectedItem.type === 'RUR') {
					ev.target.parentElement.querySelector('.js-suburb-itext').innerHTML = ('The location selected may need to be a ‘meet and greet’.');
                    $(ev.target.parentElement).addClass("tooltip-active");
				} else {
					// ev.target.parentElement.querySelector('.step-notation').style.display = 'none';
					ev.target.parentElement.querySelector('.js-suburb-itext').innerHTML = ('Please type first four letters of suburb and select suburb from list');
				}
			}
		});
	}

	QuickQuote.initSuburbAutocomplete = function (els, opts) {

		var defaults = {
			source: 'quote/suggestSuburbs',
			minLength: 2,
		};

		QuickQuote.$.extend(defaults, opts);
		els.autocomplete(defaults);
	};

	QuickQuote.getUrlPath = function (append) {
		var append = append ? append : '';
		var home = (window.location.pathname == '' || window.location.pathname == '/') ? '/home' : '';
		return window.location.pathname.replace(/\/$/, '') + home + append;
	};

	QuickQuote.getVehiclesFormData = function () {
		var $ = QuickQuote.$;
		var vehicles = [];
		var vehicleData = {};
		vehicleData['VehicleRateCode'] = CommonQuote.form.find('.js-quickvehicletype').val();
		vehicleData['VehicleRateCodeTitle'] = CommonQuote.form.find(".js-quickvehicletype option:selected").text();
		vehicles.push(vehicleData);
		return vehicles;
	}


	QuickQuote.getQuotes = function () {
		var $ = QuickQuote.$;

		var quoteTableContainer = $('.js-quotes-table-container');
		var quickQuoteResults = $('.js-quickquoteresults');
		var vehiclesArr = [];
		// QuickQuote.noQuoteMsgEl.empty(); //need to find a way to set this message
		var quotesWrapper = $('.js-quotesloadingwrapper').addClass('loading');

		$.ajax({
			type: "POST",
			url: 'quote/getQuickQuotes',
			data: {
				PickUpLocation: CommonQuote.form.find('.js-pickuplocation').val(),
				DeliveryLocation: CommonQuote.form.find('.js-deliverylocation').val(),
				AccountNo: CommonQuote.form.find('.js-getDetailsFrom').val(),
				Vehicles: QuickQuote.getVehiclesFormData()
			},
			dataType: 'json',
			success: function (data) {
				CommonQuote.quotes = data;
				var isEmptyRated = false;

				if (data && data.length && (isEmptyRated != true)) {
					$.each(data, function (index, quoteData) {
						CommonQuote.populateQuoteEl(quoteData);
					});
					CommonQuote.populateNullQuote();
					// quoteTableContainer.show();
				} else {
					CommonQuote.populateNullQuote();
				}
			}
		});
	};

//Anon
	(function ($) {

		//Dom ready
		$(function () {

			//Shadowbox
			// Shadowbox.init();

			QuickQuote.init();


		});
	})(jQuery);
}
